import React from 'react';
import { MDBCarousel, MDBCarouselItem } from 'mdb-react-ui-kit';
import img0 from './Img/0.png';
import img1 from './Img/1.png';
import img2 from './Img/2.png';
import img00 from './Img/00.png';
import img11 from './Img/11.png';
import img22 from './Img/22.png';

export default function Carousel() {
  return (
    <>
      <div className='d-block d-md-none'>
        <SM />
      </div>
      <div className='d-none d-md-block'>
        <LG />
      </div>
    </>
  );
}
const SM = () => {
  return (
    <MDBCarousel showControls fade touch={true} fluid>
      <MDBCarouselItem itemId={1}>
        <img src={img00} className='d-block w-100 zoom-hover' alt='...'/>
      </MDBCarouselItem>
      <MDBCarouselItem itemId={2}>
        <img src={img11} className='d-block w-100 zoom-hover' alt='...'/>
      </MDBCarouselItem>
      <MDBCarouselItem itemId={3}>
        <img src={img22} className='d-block w-100 zoom-hover' alt='...'/>
      </MDBCarouselItem>
    </MDBCarousel>
  )
}
const LG = () => {
  return (
    <MDBCarousel showControls fade touch={true} fluid>
      <MDBCarouselItem itemId={1}>
        <img src={img0} className='d-block w-100 ' alt='...'/>
      </MDBCarouselItem>
      <MDBCarouselItem itemId={2}>
        <img src={img1} className='d-block w-100' alt='...' />
      </MDBCarouselItem>
      <MDBCarouselItem itemId={3}>
        <img src={img2} className='d-block w-100' alt='...' />
      </MDBCarouselItem>
    </MDBCarousel>
  )
}